module.exports = __webpack_public_path__ + "img/enf-1.ae8118b6.jpg";